// ESM-Huelle um lib/scripts/pos/receipt/CLS_CReceipt.js (Phase 4, Welle 4b).
// Prototype-Stil bleibt vorerst.

// Strict-Mode-Fix (ESM): implizit zugewiesene Sloppy-Mode-Globals
// (return signature = ..., ReceiptID/first im Druck-Callback).
var signature, ReceiptID, first;
//var crypto = require('crypto');
//var node_cryptojs = require('node-cryptojs');
//var node_cryptojs = require('node-cryptojs-aes');
//var CryptoJS = require('crypto-js');
//var rs = require('jsrsasign');

function CReceipt(ReceiptID) {

    var CReceiptClass = this;
    this.defreturn = jQuery.Deferred();
    var def = jQuery.Deferred();
    //this.rkSuite = POS.RKSuite; //"R1_AT0";
    this.boxid = POS.POSId; //"DEMO-CASH-BOX473";
    this.receiptIdentifier = ReceiptID;
    if (ReceiptID) {

        this.readSharedAESSecret();
        if (!window.sigCertificateSerialNumber) {
            var cert = this.readCertificate();
            if (cert) {
                var serhex = cert.getSerialNumberHex();
                //this.signatureCertificateSerialNumber = hexToDec(serhex);
                //window.sigCertificateSerialNumber = this.h2d(serhex);
		fs.writeFile("var/etc/serial.txt",serhex); 
               window.sigCertificateSerialNumber = serhex.toUpperCase(); // Cross-File-Global (RKSV, liest CReceiptTransaction)
            } else {
                window.sigCertificateSerialNumber = 0;

            }
        }
        this.signatureCertificateSN = window.sigCertificateSerialNumber;
        this.PreviousReceipt = window.PreviousReceipt;
        if (!this.PreviousReceipt) {
            var SigTrans = new CReceiptTransaction();
            $.when(SigTrans.readDBtoReceiptLastRecord(CReceiptClass)).done(function(PR) {
                this.PreviousReceipt = PR;
                window.PreviousReceipt = PR;
                if (!this.PreviousReceipt) {
                    //noch keine Umsätze->erster Datensatz
                    window.turnovercounter = 0;
                    CReceiptClass.createDateStr();
                    CReceiptClass.receiptIdentifier = POS.firstBONID;
                    CReceiptClass.createinitializationVector(CReceiptClass.boxid + CReceiptClass.receiptIdentifier);
                    var plaindata = CReceiptClass.prepareSignatureData(null, true);
                    $.when(CReceiptClass.signDataSentence(plaindata)).then(function(sigValueHex) {
                        window.PreviousReceipt = CReceiptClass;
                        var SigTrans = new CReceiptTransaction();
                        SigTrans.insertFirstBon(CReceiptClass);
                        log.add(2, "Info", "Startbon", plaindata + '_' + CReceiptClass.jwsSignatureBase64);

                        /*
                                                var BonMan = new CBonManager();
                                                BonMan.currentBonId = CReceiptClass.receiptIdentifier;
                                                BonMan.printVC = true;
                                                BonMan.currentReceipt = CReceiptClass;
                                                BonMan.printMode = "null_receipt";
                                                BonMan.printBon(null, true, CReceiptClass.receiptIdentifier);*/

                    });
                }

                def.resolve();
            });
        } else {
            def.resolve();
        }
        if (ReceiptID > 0) {
            this.receiptIdentifier = ReceiptID;
            this.createinitializationVector(this.boxid + ReceiptID);
        }
    } else {
        def.resolve();
    }

    $.when(def).done(function() {
/*	   if (ReceiptID < 0) {
                 CReceiptClass.checkPrevReceipt();
        }*/
        CReceiptClass.defreturn.resolve(CReceiptClass);
    });

}

CReceipt.prototype.createinitializationVector = function(CashBIDReceiptNumber) {

    //var eins = this.hash(CashBIDReceiptNumber).substring(0, 32); //erste 16 Bytes
    //var zwei = CryptoJS.enc.Hex.parse(eins);
    //IV sind die rsten 16 Byte des hehashten CashBIDReceiptNumber Strings
    this.initializationVector = CryptoJS.enc.Hex.parse(this.hash(CashBIDReceiptNumber).substring(0, 32));

}

CReceipt.prototype.readSharedAESSecret = function() {
    var data = this.readKey("etc/aesKeyBase64.txt");
    var b = new Buffer(data, 'base64')
    var s = b.toString('hex');
    //this.sharedSecret = CryptoJS.enc.Hex.parse("9cf890ac4321a7292ed2f3b8197e678f502cb55727500c7ea12e7d637d06a818");
    this.sharedSecret = CryptoJS.enc.Hex.parse(s);
}

CReceipt.prototype.readKey = function(datei) {
    return fs.readFileSync(datei, "utf-8");
    /*    var fh = new CFileHandler();
        fh.fileName = datei;

        if (fh.open(false) == false) {
            log.add(2, "Info", "Das File \"" + fh.fileName + "\" konnte nicht gefunden werden", "");
            return null;
        }
        //fh.readOpen();
        return fh.readAll();*/
}

CReceipt.prototype.hash = function(plaintext) {
    return signature = CryptoJS.SHA256(plaintext).toString(); //oder key?

}

//Umsatz
CReceipt.prototype.AESTurnover = function(turnover) {

    //ar t = this.LongToWordArray(turnover);
    var wa = this.LongToByteArray(turnover);
    wa = this.ByteToWordArray(wa);
    /*
    -> die ersten 8 Byte Base64 encrypted->
    ozTcIVfY/Tc=
     */
    var actual = CryptoJS.AES.encrypt(wa, this.sharedSecret, {
        iv: this.initializationVector,
        mode: CryptoJS.mode.CTR,
        padding: CryptoJS.pad.NoPadding
    });

    //die ersten 8 Bte des 16 Byte Wertes werden genommen in Base64
    actual.ciphertext.words.splice(2, 2);
    actual.ciphertext.sigBytes = 8;
    return CryptoJS.enc.Base64.stringify(actual.ciphertext);
    //Y.Assert.areEqual(expected.toString(), actual.toString());
}

CReceipt.prototype.createDateStr = function() {

    if (!this.datestr) {
        var d = new Date();
        var dd = d.getDate().toString();
        var hh = d.getHours().toString();
        var min = d.getMinutes().toString();
        var ss = d.getSeconds().toString();
        var yyyy = d.getFullYear().toString();
  	var mm = (d.getMonth() + 1).toString(); // getMonth() is zero-based
    	mm = (mm[1] ? mm : "0" + mm[0]);
        this.datestr = yyyy + "-" + mm + "-" + (dd[1] ? dd : "0" + dd[0]) + "T" + (hh[1] ? hh : "0" + hh[0]) + ":" + (min[1] ? min : "0" + min[0]) + ":" + (ss[1] ? ss : "0" + ss[0]);
    }

}


CReceipt.prototype.checkPrevReceipt = function(def,checkanyway, wasnotworking) {

  if (!def){
    def = jQuery.Deferred();
  }
  //var wasnotworking = ((POS.Smartcard.isworking != POS.Smartcard.wasworking) && POS.Smartcard.wasworking == false); //works again -> insert zero
/*	if (wasnotworking){
		wasnotworking=true;	
	} else {  
		wasnotworking = false;
	}*/
  var CRClass = this;

  // Nacharbeit B4: an einer abgemeldeten Kasse entsteht kein Beleg mehr -
  // auch kein faelliger Monats-/Jahres-/Sammelbeleg.
  if (POS.Smartcard && POS.Smartcard.ausserBetrieb) {
      def.reject("Kasse ausser Betrieb");
      return def.promise();
  }

  // RKSV-Umbau: der letzte Beleg trug den Ausfall-Vermerk - vor diesem Beleg
  // fragen, ob die Einheit wieder signiert (Kassenserver-Probe). Wenn ja,
  // entsteht unten SOFORT der Sammelbeleg AZR (wasnotworking), nicht erst
  // nach dem naechsten erfolgreich signierten Beleg.
  if (POS.Smartcard && POS.Smartcard.isworking === false && POS.Smartcard.pruefen && !this.ausfallGeprueft) {
      this.ausfallGeprueft = true;
      $.when(POS.Smartcard.pruefen()).then(function () {
          CRClass.checkPrevReceipt(def);
      });
      return def.promise();
  }

  // if ((POS.Smartcard.isworking == true) || (checkanyway  == true)){
    var me = this;
    var d = new Date();
    var yyyy = d.getFullYear().toString();
    var mm_max_int = (d.getMonth() + 1);//.toString(); // getMonth() is zero-based
       /* if (mm_int>9){
                var mm=String(mm_int);
        else
                mm="0"+String(mm_int);
        end*/
    this.createDateStr();

    // Gleichzeitige Belege gibt es hier nicht: AddEntryPOSREG
    // (domain/bon/receiptprinter.js, inBelegReihe) serialisiert die ganze
    // Belegerzeugung - checkPrevReceipt eines Belegs (samt Nullbeleg SZR und
    // aktivieren) laeuft erst, wenn der vorige Beleg in BONREG steht.

    // Datum vorheriger Belege
    if (window.PreviousReceipt) {
        var machCodeSplit = window.PreviousReceipt.machineCodeRepOfReceipt.split('_');
        var prevReceiptDate = machCodeSplit[4];
        var datePrevSplit = prevReceiptDate.split('-');
        if (datePrevSplit.length < 2) {
            prevReceiptDate = machCodeSplit[5];
            datePrevSplit = prevReceiptDate.split('-');
        }
        var mmPrev = datePrevSplit[1];
        var yearPrev = datePrevSplit[0];
	var mmPrev_int=parseInt(mmPrev);

        var wasnotworking = ((POS.Smartcard.isworking != POS.Smartcard.wasworking) && POS.Smartcard.wasworking == false); //works again -> insert zero
        //mmPrev = '03';
        //yearPrev = '2015';
    }
    var doPrint = false;
    var cb = null;

    var yyyyPrev_int = parseInt(yearPrev);
    var yyyy_max_int = parseInt(yyyy);
    var yyyy_int=yyyyPrev_int;

    var mm_int = mmPrev_int+1;  
    if (mm_int>12){
		mm_int=1;
		yyyy_int=yyyy_int+1;
	}

   /* if (! this.PreviousReceipt){
	this.PreviousReceipt=window.PreviousReceipt;
	this.BonID=1;
    }*/
    var ym_max=yyyy_max_int*100+mm_max_int;
    var ym=yyyy_int*100+mm_int; 

    if  (((ym <= ym_max) || (wasnotworking == true)) && (this.PreviousReceipt)) { // ansonsten erster BON
        //Monatsbeleg
//        if (yyyy != yearPrev) {
	if (mm_int == 1){  //Jahresbeleg  
          var BONType = 'JVC';
            doPrint = true;
			//yyyy_int = yyyy_int + 1;
			prevReceiptDate = yyyy_int + "-01-01T00:00:00"
			cb = function(beleg){
					// Fix-Runde 2: ohne gespeicherten Jahresbeleg (beleg null) nie eine
					// Belegpruefung - der Abbruch kommt ueber die Ablehnung unten.
					if (!beleg) return;
					var callback = function(success){
						if (success){
							var text = "Die Übermittlung des Jahresbons war erfolgreich!";
							POS.message.show(text, null, "OK");
						} else {
							var text = "Die Übermittlung des Jahresbons ist fehlgeschlagen. Bitte dem Verantwortlichen melden!";
							POS.message.show(text, null, "OK"); 
						}
						CRClass.checkPrevReceipt(def);
					}
					var ws = new CWebservice();
					ws.startWebservice('belegpruefung', callback, beleg);
			}
        } else if (wasnotworking == false) {//nach Sicherheitseinrichtung ausgefallen  FALSE
            BONType = 'MVC'; //monthly 
	    if (mm_int>9){
                var mm=String(mm_int);
            } else{
                mm="0"+String(mm_int);
            }
            prevReceiptDate=yyyy_int+"-"+mm+"-01T00:00:00";

        } else {
            BONType = 'AZR';//Sicherheitseinrichtung
	               wasnotworking = false;
        }

	mm_int = mm_int + 1;
	if (mm_int>12) mm_int=1;

        $.when(me.insertZeroSentence(BONType, prevReceiptDate, doPrint, cb)).then(function(first) {
		if (!(cb)){
		CRClass.checkPrevReceipt(def);
		}
	 //def.resolve(first);
        }, function(grund) {
            // Fix-Runde 2: Nullbeleg nicht signiert/gespeichert - KEIN neuer Durchlauf
            // (er wuerde denselben faelligen Beleg wieder signieren: Endlosschleife,
            // A-Trust-Kontingent). Der ausloesende Beleg scheitert mit Meldung.
            def.reject(grund || ("Nullbeleg " + BONType + " nicht gespeichert"));
        });
        //BonManagerClass.addEntryMVC(null);
    } 
else if (POS.Smartcard && POS.Smartcard.kandidat && this.PreviousReceipt) {
        // RKSV-Wechsel (tools/RKSV-ONLINE-SIGNATUR.md 5): gibt es einen
        // vorgeprueften Kandidaten, ist der NAECHSTE Beleg der Kette ein mit ihm
        // signierter Nullbeleg SZR. Erst hier, NACH faelligen Monats-/Jahres-/
        // Sammelbelegen (die haengen am Datum des Vorbelegs und wuerden sonst
        // uebersprungen) und VOR dem Barbeleg, der dann schon neu signiert wird.
        window.sigCertificateSerialNumber = POS.Smartcard.kandidat.serialHex;
        this.signatureCertificateSN = window.sigCertificateSerialNumber;
        var szrReceiptID = parseInt(this.receiptIdentifier);
        var szrErledigt = false;
        var szrEnde = function (ok) {
            if (szrErledigt) return;
            szrErledigt = true;
            clearTimeout(szrUhr);
            var weiter = function () {
                $.when(CRClass.belegNeuAusrichten()).then(function () {
                    CRClass.checkPrevReceipt(def);
                });
            };
            if (ok) return weiter();
            // Nicht (sicher) gewechselt - z.B. aktivieren mit Fehler/Zeitlimit,
            // obwohl der Kassenserver vielleicht doch gewechselt hat: NICHT die
            // alte Seriennummer raten, sondern den Kassenserver fragen
            // (aktiv.serialHex ist die Wahrheit). Einen neuen SZR gibt es in
            // dieser Sitzung nicht - ein gescheiterter Wechsel wird beim
            // naechsten Start wiederholt.
            POS.Smartcard.kandidatVerworfen = true;   // Ruling 25
            $.when(POS.Smartcard.init(false, true)).then(function () {
                POS.Smartcard.kandidat = null;
                weiter();
            });
        };
        // Sicherheitsnetz: kein Beleg darf ewig auf den Wechsel warten.
        var szrUhr = setTimeout(function () {
            log.add(1, "Error", "RKSV", "Nullbeleg SZR/Wechsel nach 60 s nicht abgeschlossen - Beleg " + szrReceiptID);
            szrEnde(false);
        }, 60000);
        me.insertZeroSentence('SZR', this.datestr, true, function (qr) {
            if (szrErledigt) return;
            if (!qr) {
                // Kandidat hat nicht signiert -> es wurde KEIN Nullbeleg gespeichert.
                log.add(1, "Error", "RKSV", "Nullbeleg SZR nicht signiert - kein Wechsel");
                szrEnde(false);
                return;
            }
            $.when(POS.Smartcard.aktivieren(szrReceiptID, qr, window.PreviousReceipt.jwsCompactRepresentation)).then(function (ok) {
                if (!ok) log.add(1, "Error", "RKSV", "SEE-Wechsel nicht aktiviert (Beleg " + szrReceiptID + ")");
                szrEnde(ok);
            });
        });
        return def.promise();
    }
else {
      
  def.resolve();
    
 }  
 /*} // if isworking
else {
	$.when(POS.Smartcard.getSerial()).then(function(serial) {
		 if (serial==="NOK"){
			POS.Smartcard.isworking == false;
			//wasnotworking=true;
		} else {
			POS.Smartcard.isworking == true;
			wasnotworking = true;
		}
		
		CRClass.checkPrevReceipt(def,true, wasnotworking);
	});

}*/
    return def.promise();

}


// Nach dem Nullbeleg SZR (erfolgreich oder nicht): Belegnummer (mit IV fuer
// den verschluesselten Umsatzzaehler), Vorbeleg und Seriennummer des
// ausloesenden Belegs aus dem AKTUELLEN Stand neu setzen.
CReceipt.prototype.belegNeuAusrichten = function() {
    var me = this;
    var dfd = jQuery.Deferred();
    $.when(POS.SQLiteCon.lastInsertBonRegId()).done(function (ID) {
        me.receiptIdentifier = parseInt(ID) + 1;
        me.createinitializationVector(me.boxid + String(me.receiptIdentifier));
        me.PreviousReceipt = window.PreviousReceipt;
        me.signatureCertificateSN = window.sigCertificateSerialNumber;
        dfd.resolve();
    });
    return dfd.promise();
}

CReceipt.prototype.insertZeroSentence = function(BONType, date, doPrint, callback) {


    var def = jQuery.Deferred();
    var me = this;
    var thisCopied = jQuery.extend({}, this);
    thisCopied.datestr = date;
    var plaindata = thisCopied.prepareSignatureData(null, false);
    // SCH (Nacharbeit B): Schlussbeleg - signDataSentence lehnt ab (reject),
    // wenn die Signatur scheitert; dann entsteht KEIN Beleg (callback(null)).
    $.when(thisCopied.signDataSentence(plaindata, BONType === 'SZR', BONType === 'SCH')).then(function(sigValueHex) {
        //var sigValueHex = thisCopied.signDataSentence(plaindata);
        // SZR: hat der Kandidat nicht signiert, entsteht KEIN Beleg (ein
        // Nullbeleg mit neuer Seriennummer, aber ohne Signatur waere falsch).
        // prepareSignatureData hat bei Betrag 0 nichts Globales veraendert.
        if (BONType === 'SZR' && sigValueHex === 'U2ljaGVyaGVpdHNlaW5yaWNodHVuZyBhdXNnZWZhbGxlbg') {
            if (callback) callback(null);
            def.resolve(false);
            return;
        }

        var vorherigerBeleg = window.PreviousReceipt;
        window.PreviousReceipt = thisCopied;
        me.PreviousReceipt = window.PreviousReceipt;
        var SigTrans = new CReceiptTransaction();
        var nichtGespeichert = function(e) {
            // Fix-Runde 1/2: Speichern gescheitert - Aufrufer bekommt IMMER ein Ende,
            // und zwar als ABLEHNUNG (kein erneuter Versuch derselben Signatur).
            // Schlussbeleg: der Kassenserver hat gesperrt, schlussbelegSichern traegt nach.
            log.add(1, "Error", "RKSV", "Nullbeleg " + BONType + " nicht gespeichert: " + (e && e.message || e));
            window.PreviousReceipt = vorherigerBeleg;
            me.PreviousReceipt = vorherigerBeleg;
            if (callback) callback(null);
            def.reject("Nullbeleg " + BONType + " nicht gespeichert");
        };
        $.when(SigTrans.insertBon(thisCopied)).then(function(currentBonId) {
				var BonMan = new CBonManager();
				var bonZeileFehlt = function(e) {
					// Fix-Runde 2: BONREG-Zeile steht, die BON-Zeile nicht - Ende mit
					// Ablehnung (Schlussbeleg: schlussbelegSichern vervollstaendigt).
					log.add(1, "Error", "RKSV", "Nullbeleg " + BONType + ": BON-Zeile nicht gespeichert: " + (e && e.message || e));
					if (callback) callback(null);
					def.reject("Nullbeleg " + BONType + ": BON-Zeile nicht gespeichert");
				};
				$.when(BonMan.addEntryMVC(BONType)).then(function(currentBonId) {
					BonMan.currentBonId = currentBonId;
					BonMan.currentReceipt = thisCopied;
					if (doPrint) {
					  fs.unlinkSync('/tmp/whichbon.sql', function(err,data){});
					  me.printNullBon("SELECT * from BONREG where BON_ID=0 order by ReceiptId desc limit 1", BONType === 'SZR' ? "NULLBELEG SIGNATURWECHSEL" : BONType === 'SCH' ? "SCHLUSSBELEG" : "NULLBON", !doPrint, callback);
					  /*  BonMan.printVC = true;
						BonMan.currentReceipt = thisCopied;
						if (BONType == "MZR") {
							BonMan.printMode = "null_receipt";
						} else {
							BonMan.printMode = "yearly_voucher";
						}
						BonMan.printBon(null, true, thisCopied.receiptIdentifier);*/
					}
					me.receiptIdentifier = parseInt(thisCopied.receiptIdentifier) + 1;
					ReceiptID = me.receiptIdentifier;
					me.createinitializationVector(me.boxid + String(ReceiptID));
					first = false;
					def.resolve(first);
				}, bonZeileFehlt);
		}, nichtGespeichert);
    }, function(grund) {
        // Signatur abgelehnt (Schlussbeleg gescheitert bzw. Kasse ausser Betrieb):
        // nichts gespeichert, nichts gedruckt.
        log.add(1, "Error", "RKSV", "Nullbeleg " + BONType + " nicht signiert: " + grund);
        if (callback) callback(null);
        def.reject(grund || ("Nullbeleg " + BONType + " nicht signiert"));
    });
    return def.promise();

}


CReceipt.prototype.prepareSignatureData = function(BonManagerClass, first) { //sumTaxSetNormal, sumTaxSetErmaessigt1, sumTaxSetErmaessigt2, sumTaxSetNull, sumTaxSetBesonders) {

    this.Normal = Number(0).toFixed(2); //20%
    this.Ermaessigt1 = Number(0).toFixed(2); //13%
    this.Ermaessigt2 = Number(0).toFixed(2); //10%
    this.Null = Number(0).toFixed(2); //0%
    this.Besonders = Number(0).toFixed(2); //diverse z.B.: 19%

    var Total = 0;
    if (BonManagerClass) {


        var vat = BonManagerClass.vatSums;
        this.BonID = BonManagerClass.currentBonId;

        for (var i in vat["gro"]) {

            if (i == POS.VATNormal) {
                Total += Number(vat["gro"][POS.VATNormal].toFixed(2));
                this.Normal = vat["gro"][POS.VATNormal].toFixed(2); //20%
            } else if (i == POS.VATErm1) {
                Total += Number(vat["gro"][POS.VATErm1].toFixed(2));
                this.Ermaessigt1 = vat["gro"][POS.VATErm1].toFixed(2); //13%
            } else if (i == POS.VATErm2) {
                Total += Number(vat["gro"][POS.VATErm2].toFixed(2));
                this.Ermaessigt2 = vat["gro"][POS.VATErm2].toFixed(2); //10%
            } else if (i == POS.VATNull) {
                Total += Number(vat["gro"][POS.VATNull].toFixed(2));
                this.Null = vat["gro"][POS.VATNull].toFixed(2); //0%
            } else {
                Total += Number(vat["gro"][i].toFixed(2));
                this.Besonders = vat["gro"][i].toFixed(2); //diverse z.B.: 19%
            }
        }

    }
    if (!this.BonID) {
        this.BonID = 0;
    }
    /*
    var Normal = vat["gro"][POS.VATNormal].toFixed(2);//20%
    var Ermaessigt1 =  vat["gro"][POS.VATErm1].toFixed(2);//13%
    var Ermaessigt2 =  vat["gro"][POS.VATErm2].toFixed(2);//10%
    var Null =  vat["gro"][POS.VATNull].toFixed(2);//0%
    var Besonders = sumTaxSetBesonders.toFixed(2);//diverse z.B.: 19%*/
    //var Total = Number(this.Normal) + Number(this.Ermaessigt1) + Number(this.Ermaessigt2) + Number(this.Null) + Number(this.Besonders);

    window.turnovercounter += Number((Number(Total) * 100).toFixed(0));
    //parseFloat(Math.round(num3 * 100) / 100).toFixed(2);
    //SATZ_NORMAL  SATZ_ERMAESSIGT_1 SATZ_ERMAESSIGT_2 SATZ_NULL SATZ_BESONDERS
    // Sätze auf 2 Komma gerundet, -> aufsummiert = Umsatz
    this.TurnoverValue = window.turnovercounter;
    this.encryptedTurnoverValue = this.AESTurnover(window.turnovercounter);
    this.signatureValuePreviousReceipt = this.sigPrevReceipt(first);
    return this.createMachineCodeRep();
}

CReceipt.prototype.createMachineCodeRep = function() {
    this.machineCodeRepOfReceipt = "_" + POS.RKSuite + "_" + this.boxid + "_" + this.receiptIdentifier + "_" + this.datestr + "_" + this.Normal.replace(".", ",") + "_" +
        this.Ermaessigt1.replace(".", ",") + "_" + this.Ermaessigt2.replace(".", ",") + "_" + this.Null.replace(".", ",") + "_" +
        this.Besonders.replace(".", ",") + "_" + this.encryptedTurnoverValue + "_" + this.signatureCertificateSN + "_" + this.signatureValuePreviousReceipt;
    return this.machineCodeRepOfReceipt;
}

// kandidat=true: mit dem Wechsel-Kandidaten signieren (nur Nullbeleg SZR).
// schlussbeleg=true: Schlussbeleg SCH (Nacharbeit B). Lehnt der Kassenserver
// ab (Kasse ausser Betrieb, Schlussbeleg nicht signiert), wird das Deferred
// abgelehnt - nie ein Beleg mit Ausfall-Vermerk.
CReceipt.prototype.signDataSentence = function(plaintext, kandidat, schlussbeleg) {

    var def = jQuery.Deferred();
    //var b64 = btoa(plaintext);
    var encodedb64 = this.base64url_encode(btoa(plaintext));
    //X1IxLUFUMF9ERU1PLUNBU0gtQk9YNDczXzEyMzQ1Nl8yMDE2LTAxLTE0VDA5OjU0OjQwXzAsMDBfMCwwMF8wLDAwXzAsMDBfMCwwMF8vK0cwbk4yZzZ6dz1fNjAwMDkyNzI1MDAyNjk4Mzc0M19nWXp6cXZDcTg0VT0
    var jwsHeaderBase64Url = "eyJhbGciOiJFUzI1NiJ9";
    this.jwsDataToBeSigned = jwsHeaderBase64Url + "." + encodedb64;


    ////////////////////////////////////
    /*
        var curve = "secp256r1"; //f1.curve1.value;
        var sigalg = "SHA256withECDSA"; //f1.sigalg1.value;

        var sig = new rs.crypto.Signature({
            "alg": sigalg,
            "eccurvename": curve
        });
        //sig.init(data);
        var prvkey = this.readSigningKey();
        sig.initSign({
            'ecprvhex': prvkey,
            'eccurvename': curve
        });
        sig.updateString(this.jwsDataToBeSigned);
        this.signeddata = sig.sign(); //DER encoded
        this.signeddata = this.signeddata.substring(this.signeddata.length - 64);
    */
    /////////////////////////////////


    //bei Ausfall: 'Sicherheitseinrichtung ausgefallen'
    /*Der Hinweis „Sicherheitseinrichtung ausgefallen“ ist zusätzlich gut sichtbar
am Beleg (§ 11) anzubringen. Nach Wiederinbetriebnahme der Signaturerstellungseinheit ist zusätzlich
über die Belege, die während des jeweiligen Ausfalles mit dem Hinweis „Sicherheitseinrichtung
ausgefallen“ zu versehen waren, ein signierter Sammelbeleg mit Betrag Null (0) zu erstellen und im
Datenerfassungsprotokoll zu speichern.*/
    var me = this;

    $.when(POS.Smartcard.sign(this.jwsDataToBeSigned, kandidat, schlussbeleg)).then(function(data) {
        //me.signeddata = data;
        //me.jwsSignatureBase64 = btoa(me.signeddata);
        me.jwsSignatureBase64 = data.toString('base64');
        me.jwsSignatureBase64Url = me.base64url_encode(me.jwsSignatureBase64);
        me.getJwsCompactRepresentation();
//me.doVerify(me.jwsDataToBeSigned, data);
        def.resolve(me.jwsSignatureBase64Url);
    }, function(grund) { def.reject(grund); });

    //  return this.jwsSignatureBase64Url;
    return def.promise();
}

CReceipt.prototype.setParameters = function(ReceiptID, Date, TAXNormal, TAXErm1,
    TAXErm2, TAXNull, TAXBes, TurnoverEncr, CertSerial, SigHex, CompactRep) {

    this.receiptIdentifier = ReceiptID;
    this.datestr = Date;
    this.Normal = Number(TAXNormal).toFixed(2);
    this.Ermaessigt1 = Number(TAXErm1).toFixed(2);
    this.Ermaessigt2 = Number(TAXErm2).toFixed(2);
    this.Null = Number(TAXNull).toFixed(2);
    this.Besonders = Number(TAXBes).toFixed(2);
    this.encryptedTurnoverValue = TurnoverEncr;
    this.signatureCertificateSN = CertSerial;
    this.signatureValuePreviousReceipt = SigHex;
    this.createMachineCodeRep();
    /*var encodedb64 = this.base64url_encode(btoa(this.machineCodeRepOfReceipt));
    //X1IxLUFUMF9ERU1PLUNBU0gtQk9YNDczXzEyMzQ1Nl8yMDE2LTAxLTE0VDA5OjU0OjQwXzAsMDBfMCwwMF8wLDAwXzAsMDBfMCwwMF8vK0cwbk4yZzZ6dz1fNjAwMDkyNzI1MDAyNjk4Mzc0M19nWXp6cXZDcTg0VT0
    var jwsHeaderBase64Url = "eyJhbGciOiJFUzI1NiJ9";
    this.jwsDataToBeSigned = jwsHeaderBase64Url + "." + encodedb64;*/
    this.jwsCompactRepresentation = CompactRep;
    var s = String(CompactRep).split(".");
    this.jwsDataToBeSigned = s[0] + "." + s[1];
    this.jwsSignatureBase64Url = s[2];
    this.jwsSignatureBase64 = this.base64url_decode(this.jwsSignatureBase64Url);
    //this.signDataSentence(this.createMachineCodeRep());

}

CReceipt.prototype.getQRCodeRepresentation = function() {
    return this.machineCodeRepOfReceipt + "_" + this.jwsSignatureBase64;
}

CReceipt.prototype.getOCRCodeRepresentation = function() {
    //Base32 encodiert


}

CReceipt.prototype.exportDEP = function(Start, End) {
    //alle
    //var json_text = JSON.stringify(your_object, null, 2);
    var dfd = jQuery.Deferred();
    var SigTrans = new CReceiptTransaction();
    // RKSV-Umbau: eine Belege-Gruppe je Signaturzertifikat (RKSV Anlage Z 3).
    // Gruppiert wird nach zusammenhaengenden Laeufen von BONREG.CertSerial
    // (Schluss-Befund I4); das Zertifikat je Seriennummer kommt aus der
    // SEE-Historie des Kassenservers - dort steht auch das eines Kandidaten,
    // der nur einen (gestrandeten) Nullbeleg SZR signiert hat. Laeufe ohne
    // Historien-Zertifikat bekommen var/etc/certificate.cer NUR, wenn deren
    // Seriennummer (jsrsasign getSerialNumberHex) zur Lauf-Seriennummer passt
    // oder der Lauf nur Ausfall-/Stub-Belege (Seriennummer 0) hat; sonst eine
    // Gruppe mit leerem Signaturzertifikat + Log (Nacharbeit A4). Die Belege
    // bleiben IMMER im Export. Seriennummern werden ueberall NUMERISCH
    // verglichen (Hex ohne Vornullen, Leerzeichen/Gross-klein egal).
    $.when(SigTrans.getCompactRepresentationMitId(Start, End)).done(function(rows) {
        if (rows) {
            var ohneRahmen = function (c) {
                return String(c).replace('-----BEGIN CERTIFICATE-----', '').replace('-----END CERTIFICATE-----', '').replace(/\r?\n|\r/g, '');
            };
            var provcert = ohneRahmen(fs.readFileSync("etc/ATrust.cer").toString());
            // Befund M6: fehlt certificate.cer, antwortet /file mit "NOK ..." -
            // das ist nie ein Zertifikat. Die Belege bleiben trotzdem im DEP
            // (jeder Beleg des Bereichs muss drin sein): leeres
            // Signaturzertifikat + Log (Gate-Nachtrag, korrigiert M6).
            var bisherigesGelesen = false, bisheriges = null, bisherigesSerie = null;
            var serieZahl = function (x) {
                var h = String(x === null || x === undefined ? "" : x).replace(/\s+/g, "").toUpperCase();
                if (!/^[0-9A-F]+$/.test(h)) return null;
                h = h.replace(/^0+/, "");
                return h === "" ? "0" : h;
            };
            var bisherigesZertifikat = function () {
                if (!bisherigesGelesen) {
                    bisherigesGelesen = true;
                    var roh = fs.readFileSync("var/etc/certificate.cer");
                    bisheriges = (roh === undefined || roh === null || /^NOK/.test(String(roh))) ? null : ohneRahmen(roh.toString());
                    if (bisheriges) {
                        try {
                            var x509 = new rs.X509();
                            x509.hex = rs.b64tohex(bisheriges);
                            bisherigesSerie = serieZahl(x509.getSerialNumberHex());
                        } catch (e) { bisherigesSerie = null; }
                    }
                }
                return bisheriges;
            };
            // Fix-Runde 1: echte Kassen haben die Zertifikate frueherer Karten
            // unter etc/certificate*.cer (PEM, Base64-DER oder rohes DER).
            // Passt ein Lauf weder zur SEE-Historie noch zu
            // var/etc/certificate.cer, wird dort nach seiner Seriennummer
            // gesucht (numerisch); unlesbare Dateien werden uebersprungen.
            var serieAusB64 = function (b64) {
                try {
                    var hex = rs.b64tohex(b64);
                    if (!/^30/i.test(hex)) return null;
                    var x = new rs.X509();
                    x.hex = hex;
                    return serieZahl(x.getSerialNumberHex());
                } catch (e) { return null; }
            };
            var binaerHex = function (pfad) {
                try {
                    var x = new XMLHttpRequest();
                    x.open("POST", "file", false);
                    x.overrideMimeType("text/plain; charset=x-user-defined");
                    x.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
                    x.send("file=" + encodeURIComponent(fs.absPath(pfad)) + "&type=rb");
                    if (x.status !== 200) return null;
                    var t = x.responseText, h = "";
                    for (var i = 0; i < t.length; i++) h += ("0" + (t.charCodeAt(i) & 0xff).toString(16)).slice(-2);
                    return h;
                } catch (e) { return null; }
            };
            var zertAusDatei = function (hex) {
                if (!hex) return null;
                if (/^30/i.test(hex)) {                       // rohes DER
                    var der = rs.hex2b64(hex);
                    if (serieAusB64(der) !== null) return der;
                }
                var text = "";
                for (var i = 0; i + 1 < hex.length; i += 2) text += String.fromCharCode(parseInt(hex.substr(i, 2), 16));
                var b64 = ohneRahmen(text).replace(/\s+/g, "");
                return /^[A-Za-z0-9+\/=]+$/.test(b64) && serieAusB64(b64) !== null ? b64 : null;
            };
            var weitereGelesen = false, weitere = {};
            var weitereZertifikate = function () {
                if (weitereGelesen) return weitere;
                weitereGelesen = true;
                var namen = [];
                try { namen = String(fs.readdirSync("etc/") || "").split("\n"); } catch (e) { namen = []; }
                namen.forEach(function (name) {
                    name = String(name).trim();
                    if (!/^certificate.*\.cer$/i.test(name)) return;
                    var zert = zertAusDatei(binaerHex("etc/" + name));
                    var n = zert ? serieAusB64(zert) : null;
                    if (n !== null && !weitere.hasOwnProperty(n)) weitere[n] = zert;
                });
                return weitere;
            };
            var bauen = function (zertifikate) {
                var jeSerie = {};
                zertifikate.forEach(function (z) {
                    var n = z ? serieZahl(z.serialHex) : null;
                    if (n !== null && z.zertifikat) jeSerie[n] = z.zertifikat;
                });
                bisherigesZertifikat();
                // Schluessel je Beleg: E<n> eigenes Historien-Zertifikat,
                // R Rueckfall certificate.cer (Seriennummer 0 oder passend),
                // X<n> passendes etc/certificate*.cer, L<n> kein passendes Zertifikat. Gleiche Schluessel
                // hintereinander bilden eine Gruppe.
                var laeufe = [];
                rows.forEach(function (r) {
                    var serie = String(r.CertSerial === null || r.CertSerial === undefined ? "" : r.CertSerial);
                    var n = serieZahl(serie);
                    var schluessel, zert;
                    if (n !== null && jeSerie.hasOwnProperty(n)) { schluessel = "E" + n; zert = jeSerie[n]; }
                    else if (n === "0" || (n !== null && n === bisherigesSerie)) { schluessel = "R"; zert = null; }
                    else if (n !== null && weitereZertifikate().hasOwnProperty(n)) { schluessel = "X" + n; zert = weitere[n]; }
                    else { schluessel = "L" + (n === null ? "?" + serie : n); zert = ""; }
                    var letzter = laeufe[laeufe.length - 1];
                    if (letzter && letzter.schluessel === schluessel) {
                        letzter.belege.push(r.ReceiptComp);
                    } else {
                        laeufe.push({ schluessel: schluessel, serie: serie, zert: zert, belege: [r.ReceiptComp] });
                    }
                });
                var BelegeGruppe = [];
                laeufe.forEach(function (l) {
                    var zert = l.zert;
                    if (zert === null) {
                        zert = bisheriges;
                        if (zert === null) {
                            log.add(1, "Error", "RKSV", "DEP-Export: kein Signaturzertifikat fuer " + l.belege.length +
                                " Belege ab Seriennummer " + l.serie + " (var/etc/certificate.cer fehlt) - Gruppe mit leerem Signaturzertifikat");
                            zert = "";
                        }
                    } else if (zert === "") {
                        log.add(1, "Error", "RKSV", "DEP-Export: " + l.belege.length + " Belege mit Seriennummer " + l.serie +
                            " - nicht in der SEE-Historie, var/etc/certificate.cer (Seriennummer " + (bisherigesSerie === null ? "unbekannt" : bisherigesSerie) +
                            ") passt nicht, kein passendes etc/certificate*.cer - Gruppe mit leerem Signaturzertifikat");
                    }
                    BelegeGruppe.push({
                        "Signaturzertifikat": zert,
                        "Zertifizierungsstellen": [provcert],
                        "Belege-kompakt": l.belege
                    });
                });
                dfd.resolve(JSON.stringify({ "Belege-Gruppe": BelegeGruppe }));
            };
            $.ajax({
                url: "rksv/dep-gruppen", cache: false, timeout: 10000,
                success: function (a) { bauen(a && a.ok && a.zertifikate ? a.zertifikate : []); },
                error: function () { bauen([]); }
            });
        } else {
            var text = "Es ist ein Fehler aufgetreten oder es konnten für diesen Zeiraum keine Belege gefunden werden!"
            POS.message.show(text, "warning", "OK");
            dfd.resolve("");

        }
    });
    //this.jwsDataToBeSigned + "." + this.jwsSignatureBase64URL;// =Kompaktrepräsentation
    return dfd.promise();
}

CReceipt.prototype.base64url_encode = function(data) {
    //var b64 = btoa(data);
    var b64 = data;
    b64 = b64.replace(/=+$/, '');
    b64 = b64.replace(/\+/g, '-');
    b64 = b64.replace(/\//g, '_');
    return b64;
}


CReceipt.prototype.base64url_decode = function(data) {

    // Add removed at end '='
    var base64 = data + "==";
    //  base64 += Array(5 - base64.length % 4).join('=');

    base64 = base64
        .replace(/\-/g, '+') // Convert '-' to '+'
        .replace(/\_/g, '/'); // Convert '_' to '/'

    return base64;

};

CReceipt.prototype.getJwsCompactRepresentation = function() {
    this.jwsCompactRepresentation = this.jwsDataToBeSigned + "." + this.jwsSignatureBase64Url;
}

CReceipt.prototype.sigPrevReceipt = function(first) {

    //plaintext = jwsDataToBeSigned e.g. eyJhbGciOiJFUzI1NiJ9.X1IxLUFUMF9ERU1PLUNBU0gtQk9YNDczXzEyMzQ1Nl8yMDE2LTAxLTE0VDA5OjU0OjQwXzAsMDBfMCwwMF8wLDAwXzAsMDBfMCwwMF8vK0cwbk4yZzZ6dz1fNjAwMDkyNzI1MDAyNjk4Mzc0M19nWXp6cXZDcTg0VT0

    var bytesToExtract = 8; //num

    if (first) {
        var prevhash = this.hash(this.boxid);
    } else {
        prevhash = this.hash(this.PreviousReceipt.jwsCompactRepresentation);
    }
    /*

    Base64 der ersten 8 Bytes gYzzqvCq84U=
     */
    //extract number of bytes (N, defined in RKsuite) from hash value

    var words = CryptoJS.enc.Hex.parse((prevhash).substring(0, 2 * bytesToExtract));
    return CryptoJS.enc.Base64.stringify(words);
}

/*
CReceipt.prototype.readSigningKey = function() {
    var data = this.readKey("etc/signingKey.txt");
    //data = "MEECAQAwEwYHKoZIzj0CAQYIKoZIzj0DAQcEJzAlAgEBBCDjq5edqZLcbT0JtlKWiJaXiopdJsIYcnqr9LzzcNwAFA==";
    var b = new Buffer(data, 'base64')
    var derprvkey = b.toString('hex');
    return derprvkey.substring(derprvkey.length - 64); //nur die letzten 256 BIT = Key length

}
*/
/*

return " _ " + rkSuite.getSuiteID() + " _ " + cashBoxID + " _ " + receiptIdentifier + " _ " + dateFormat.format(receiptDateAndTime) + " _ " + decimalFormat.format(sumTaxSetNormal) + " _ " + decimalFormat.format(sumTaxSetErmaessigt1) + " _ " + decimalFormat.format(sumTaxSetErmaessigt2) + " _ " + decimalFormat.format(sumTaxSetNull) + " _ " + decimalFormat.format(sumTaxSetBesonders) + " _ " + encryptedTurnoverValue + " _ " + signatureCertificateSerialNumber + " _ " + signatureValuePreviousReceipt;
_R1-AT0_DEMO-CASH-BOX473_123456_2016-01-12T16:42:34_0,00_0,00_0,00_0,00_0,00_ozTcIVfY/Tc=_5633631506111725924_gYzzqvCq84U=
Base64: X1IxLUFUMF9ERU1PLUNBU0gtQk9YNDczXzEyMzQ1Nl8yMDE2LTAxLTEyVDE2OjQyOjM0XzAsMDBfMCwwMF8wLDAwXzAsMDBfMCwwMF9velRjSVZmWS9UYz1fNTYzMzYzMTUwNjExMTcyNTkyNF9nWXp6cXZDcTg0VT0
 */
CReceipt.prototype.doVerify = function(msg1, sigval) {

   // var data = this.readKey("etc/signatureCertificates.txt");
 var data = this.readKey("var/etc/certificate.cer");
  

	var getHex=function bufferToHex(buffer) {
    		var s = '', h = '0123456789ABCDEF';
    		(new Uint8Array(buffer)).forEach((v) => { s += h[v >> 4] + h[v & 15]; });
    		return s;
	}
	
	sigval=getHex(sigval);

  /*var X509 = new rs.X509();
    X509.readCertPEM(data);*/
    //data = "MFkwEwYHKoZIzj0CAQYIKoZIzj0DAQcDQgAEu1dO5ofxd7kC21zgnO8NX7Eh6l5dhqTUgTUydcv6nYkSVipMWnuf4k8K4M0yYhj9rgFfOEOsZZBekpul1JnynQ==";
    //encoded: 3059301306072A8648CE3D020106082A8648CE3D03010703420004BB574EE687F177B902DB5CE09CEF0D5FB121EA5E5D86A4D481353275CBFA9D8912562A4C5A7B9FE24F0AE0CD326218FDAE015F3843AC65905E929BA5D499F29D
    //nicht encodd  bb574ee687f177b902db5ce09cef0d5fb121ea5e5d86a4d481353275cbfa9d8912562a4c5a7b9fe24f0ae0cd326218fdae015f3843ac65905e929ba5d499f29d
    var curve = "secp256r1"; //f1.curve1.value;
    var sigalg = "SHA256withECDSA"; //f1.sigalg1.value;
    var sig = new rs.crypto.Signature({
        "alg": sigalg
    });
    data="-----BEGIN CERTIFICATE-----"+data+"-----END CERTIFICATE-----\n";
    var certdata = rs.KEYUTIL.getKey(data);
    var pubkey = certdata.pubKeyHex;

    sig.initVerifyByPublicKey({
        'ecpubhex': pubkey,
        'eccurvename': curve
    });
    sig.updateString(msg1);
    var result = sig.verify(sigval);
    if (result) {
        alert("valid ECDSA signature");
    } else {
        alert("invalid ECDSA signature");
    }
}

CReceipt.prototype.readCertificate = function(filename) {
    try {
        if (!filename) {
            filename = "var/etc/certificate.cer";
        }
        var data = this.readKey(filename);
        var x509 = new rs.X509();
        if (data) {
            x509.readCertPEM(data);
        } else {
            return null;
        }
        return x509;
    } catch (e) {
        log.add(2, "Info", "Das Zertificat  konnte nicht gelesen werden", "");
        return null;
    }

}

CReceipt.prototype.findCertificatesBySerial = function(suffix, serial) {

    if (!suffix) {
        suffix = "cert";
    }
    var foundcerts = [];
    var dh = new CDirectoryHandler("etc");
    var certs = dh.read(false);
    for (i in certs) {
        var lastIndex = certs[i].lastIndexOf(suffix);
        var result = (lastIndex !== -1) && (lastIndex + suffix.length === certs[i].length);
        if (result) {
            var x509 = this.readCertificate(certs[i]);
            var serhex = x509.getSerialNumberHex();
            //this.signatureCertificateSerialNumber = hexToDec(serhex);
            //  var serialnumber = this.h2d(serhex);
            var serialnumber = serhex.toUpperCase();
            if (this.signatureCertificateSN == serialnumber) {
                var c = [];
                var l = this.readKey(certs[i]);
                var lines = l.split('\n');
                c[0] = lines[1];
                var issuer = x509.getIssuerString();
                c[1] = this.findCertificatesBySubject("cert", issuer);
                foundcerts[serialnumber] = c;
            }
        }
    }
    return foundcerts;
}

CReceipt.prototype.findCertificatesBySubject = function(suffix, subject, foundcert) {

        if (!suffix) {
            suffix = "cert";
        }
        if (!foundcert) {
            foundcert = [];
        }
        var dh = new CDirectoryHandler("etc");
        var certs = dh.read(false);
        for (i in certs) {
            var lastIndex = certs[i].lastIndexOf(suffix);
            var result = (lastIndex !== -1) && (lastIndex + suffix.length === certs[i].length);
            if (result) {
                var x509 = this.readCertificate(certs[i]);
                var subject2 = x509.getSubjectString();
                //this.signatureCertificateSerialNumber = hexToDec(serhex);

                if (subject2 == subject) {
                    var l = this.readKey(certs[i]);
                    var lines = l.split('\n');
                    foundcert.push(lines[1]);
                    var issuer = x509.getIssuerString();
                    this.findCertificatesBySubject("cert", issuer, foundcert);
                }
            }
        }
        return foundcert;
    }
    /*
    CReceipt.prototype.test = function(plaintext) {

        //var t = serhex.toString(16);


        this.readSharedAESSecret();

        plaintext = this.prepareSignatureData("123456", 52.37, 0, 0, 27.61, 0.25);
        var sigValueHex = this.signDataSentence(plaintext);
        //plaintext = "_R1-AT0_DEMO-CASH-BOX473_123456_2016-01-14T09:54:40_0,00_0,00_0,00_0,00_0,00_/+G0nN2g6zw=_6000927250026983743_gYzzqvCq84U=";


        // nur zum test
        var b64 = btoa(plaintext);
        //X1IxLUFUMF9ERU1PLUNBU0gtQk9YNDczXzEyMzQ1Nl8yMDE2LTAxLTE0VDA5OjU0OjQwXzAsMDBfMCwwMF8wLDAwXzAsMDBfMCwwMF8vK0cwbk4yZzZ6dz1fNjAwMDkyNzI1MDAyNjk4Mzc0M19nWXp6cXZDcTg0VT0
        var jwsHeaderBase64Url = "eyJhbGciOiJFUzI1NiJ9";
        var jwsDataToBeSigned = jwsHeaderBase64Url + "." + b64.slice(0, -1); //Das "=" am Ende weg!
        //


        var f = new CFileHandler();
        f.fileName = "/mnt/share/output.txt";
        f.overwriteSync(sigValueHex + "\n");
        f.appendSync(jwsDataToBeSigned + "\n");
        f.appendSync(plaintext);

        this.doVerify(jwsDataToBeSigned, sigValueHex);

    }
    */
CReceipt.prototype.h2d = function(s) {

    function add(x, y) {
        var c = 0,
            r = [];
        var x = x.split('').map(Number);
        var y = y.split('').map(Number);
        while (x.length || y.length) {
            var s = (x.pop() || 0) + (y.pop() || 0) + c;
            r.unshift(s < 10 ? s : s - 10);
            c = s < 10 ? 0 : 1;
        }
        if (c)
            r.unshift(c);
        return r.join('');
    }

    var dec = '0';
    s.split('').forEach(function(chr) {
        var n = parseInt(chr, 16);
        for (var t = 8; t; t >>= 1) {
            dec = add(dec, dec);
            if (n & t)
                dec = add(dec, '1');
        }
    });
    return dec;
}

CReceipt.prototype.LongToByteArray = function(long) {
    // we want to represent the input as a 8-bytes array
    var byteArray = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

    for (var index = byteArray.length - 9; index >= 0; index--) {
        var byte = long & 0xff;
        byteArray[index] = byte;
        long = (long - byte) / 256;
    }

    return byteArray;
};

// Converts ByteArray to stadnard WordArray.
// Example: CryptoJS.MD5(CryptoJS.lib.ByteArray ([ Bytes ])).toString(CryptoJS.enc.Base64);
CReceipt.prototype.ByteToWordArray = function(arr) {
    var word = [];
    for (var i = 0; i < arr.length; i += 4) {
        word.push(arr[i + 0] << 24 | arr[i + 1] << 16 | arr[i + 2] << 8 | arr[i + 3] << 0);
    }

    return CryptoJS.lib.WordArray.create(word, arr.length);
};


CReceipt.prototype.DWordToByteArray = function(dword) {
    // we want to represent the input as a 8-bytes array
    //var wordArray = new CryptoJS.enc.Utf8.parse("teststring");
    var byteArray = [0, 0, 0, 0];

    for (var index = 3; index >= 0; index--) {
        var byte = dword & 0xff;
        byteArray[index] = byte;
        dword = (dword - byte) / 256;
    }

    return byteArray;
};

CReceipt.prototype.byteArrayToLong = function( /*byte[]*/
    byteArray) {
    var value = 0;
    for (var i = 0; i < byteArray.length - 9; i++) {
        value = (value * 256) + byteArray[i];
    }

    return value;
};


CReceipt.prototype.printNullBon = function(sql, text, dontprint, callback) { /*byte[]*/

    try {
        if (!text) {
            text = 'STARTBON';
        }

        var printBon = function(QRCodeRep, CompactRep) {
            //var QRCodeRep = Receipt.getQRCodeRepresentation();
            log.add(1, "Info", QRCodeRep);
			console.log(QRCodeRep);
			if (callback) callback(QRCodeRep);
			if (dontprint){
					return;
			}

            //    $.when(Receipt.signDataSentence(plaindata)).then(function(sigValueHex) {
            debugger;
            Printer = new CPrinter();
            Printer.addLine("A", 1, false, 0);
            Printer.addElement(text, 20, 2, true, 0, 41);
            Printer.addLine("A", 1, false, 0);
            text= "R.Bigl Ges.m.b.H.";
            Printer.addElement(text, 20, 2, true, 0, 41);
            Printer.addLine("A", 1, false, 0);
            text= "UID: ATU 43173409";
            Printer.addElement(text, 20, 2, true, 0, 41);
            Printer.addLine("A", 1, false, 0);
            text = 'Summe: 0 EUR';
            Printer.addElement(text, 20, 2, true, 0, 41);
            Printer.addLine("A", 1, false, 0);
            text = 'Rechnungsnummer: ' +  String(Receipt.receiptIdentifier);
            Printer.addElement(text, 20, 2, true, 0, 41);
            Printer.addLine("A", 1, false, 0);
            text = 'Kassen-ID: ' + Receipt.boxid;
            Printer.addElement(text, 20, 2, true, 0, 41);
            Printer.addLine("A", 1, false, 0);
            text = 'Datum: ' + Receipt.datestr.replace('T', '  ');
            Printer.addElement(text, 20, 2, true, 0, 41);
            Printer.addLine("A", 1, false, 0);

            //text = 'BON-ID: ' +  rows[0].ReceiptID;
            //Printer.addElement(text, 20, 2, true, 0, 41);
            /*                       var hini = 145;
        var scy = 0.75;

        for (z=1;z<30;z++){
          h = hini-z;
          var y = scy;
      //  var y = scy - (z/100);
        qrcode = new qr({
            doc: document,
            heigth: h,
            width: h,
            scaleX: 1,
            scaleY: y
        });
*/
            var commandbuffer = qrcode.QRCodePOSCommand($, QRCodeRep);
            Printer.addLine("A", 1, false, 0);
            Printer.addImageLine(commandbuffer);
            Printer.addLine("A", 1, false, 0);
            /*       var text = h +' '+y;
                    Printer.addElement(text, 20, 2, true, 0, 41);
                    Printer.addLine("A", 1, false, 0);
            */
            //    }

            var textlang = 'QRCode: ' + QRCodeRep;
            var x = 0;
            while (x < textlang.length) {
                text = textlang.substr(x, 35);
                x = x + 35;
                Printer.addElement(text, 20, 2, true, 0, 41);
                Printer.addLine("A", 1, false, 0);
            }
            textlang = 'Compact: ' + CompactRep;
            x = 0;
            while (x < textlang.length) {
                text = textlang.substr(x, 35);
                x = x + 35;
                Printer.addElement(text, 20, 2, true, 0, 41);
                Printer.addLine("A", 1, false, 0);
            }
            //Printer.spPath = "/tmp/";
            Printer.print();
            //Printer.spPath = "/home/pos/spooler/";
        }
        debugger;
	sql = "SELECT * from BONREG order by ReceiptID desc limit 1";

        try {
            var t = fs.readFileSync('/tmp/whichbon.sql', "utf-8");
            // Der Node-Kassenserver antwortet bei fehlender Datei mit "NOK ..."
            // statt einer Ausnahme - sonst liefe "NOK ENOENT..." als SQL und
            // der Nullbeleg-Druck (JVC/SZR) braeche mit TypeError ab.
            if (!t || String(t).indexOf("NOK") === 0) throw new Error("keine /tmp/whichbon.sql");
            var ts = t.split('|');
            sql = ts[0];
            if (ts.length > 1) {
                text = ts[1];
            }
        } catch (e) {
            if (!sql) {
                sql = "SELECT * from BONREG order by ReceiptID desc limit 1";
            }
        }
	if (sql===""){
		 sql = "SELECT * from BONREG order by ReceiptID desc limit 1";
	}
        var Receipt = new CReceipt();
        $.when(Receipt.defreturn).done(function(c) {
            $.when(POS.SQLiteCon.execute(sql)).then(function(rows) {

                //var turnovercounter = rows[0].TurnoverCounter;
                //  turnovercounter =0;
                // FUNKTIONSLOKALES turnovercounter (Original-Scope erhalten -
                // nicht das RKSV-Cross-File-Global window.turnovercounter!)
                var turnovercounter = Number((Number(rows[0].TurnoverCounter) * 100).toFixed(0));
                //  Receipt.readSharedAESSecret();
                Receipt.TurnoverValue = turnovercounter;
                Receipt.datestr = rows[0].Date;
                Receipt.receiptIdentifier = rows[0].ReceiptID;
                //Receipt.createinitializationVector(Receipt.boxid +  Receipt.receiptIdentifier);
                Receipt.Normal = Number(0).toFixed(2); //20%
                Receipt.Ermaessigt1 = Number(0).toFixed(2); //13%
                Receipt.Ermaessigt2 = Number(0).toFixed(2); //10%
                Receipt.Null = Number(0).toFixed(2); //0%
                Receipt.Besonders = Number(0).toFixed(2); //diverse z.B.: 19%
                Receipt.Besonders = Number(0).toFixed(2); //diverse z.B.: 19%
                var Total = 0;
                Receipt.BonID = 0;
                Receipt.signatureCertificateSN = rows[0].CertSerial;

                Receipt.encryptedTurnoverValue = rows[0].TurnoverEncr; //Receipt.AESTurnover(Receipt.TurnoverValue);
                //    Receipt.signatureValuePreviousReceipt = Receipt.sigPrevReceipt(true);
                Receipt.signatureValuePreviousReceipt = rows[0].SigHex;
                var plaindata = Receipt.createMachineCodeRep();

                if (rows[0].ReceiptComp && rows[0].ReceiptComp.length > 10) {
                    var CompactRep = rows[0].ReceiptComp;
                    var s = CompactRep.split(".");
                    Receipt.jwsDataToBeSigned = s[0] + "." + s[1];
                    Receipt.jwsSignatureBase64Url = s[2];
                    Receipt.jwsSignatureBase64 = Receipt.base64url_decode(Receipt.jwsSignatureBase64Url);
                    printBon(Receipt.getQRCodeRepresentation(), CompactRep);
                } else {
                    Receipt.createinitializationVector(Receipt.boxid + Receipt.receiptIdentifier);
                    //var plaindata = Receipt.prepareSignatureData(null, true);


                    $.when(Receipt.signDataSentence(plaindata)).then(function(sigValueHex) {
                        Receipt.getJwsCompactRepresentation();
                        printBon(Receipt.getQRCodeRepresentation(), Receipt.jwsCompactRepresentation);
                    });

                }

		  console.log('printNullBon' + plaindata);

                /*$.when(BonMan.printBon(null, true, 0)).done(function() {
                    //r10.resolve();
                });*/
                //    });
            });
        });
        debugger;
    } catch (e) {
        console.log(e);

    }

}


//# sourceURL=CLS_CReceipt.js

export { CReceipt };
